export const videoTypeOptions = [
  {
    label: "选择视频",
    value: "uploadVideo"
  },
  {
    label: "视频地址",
    value: "videoUrl"
  },
  {
    label: "视频库",
    value: "videoLibrary"
  }
];

export const coverTypeOptions = [
  {
    label: "默认",
    value: "default"
  },
  {
    label: "选择图片",
    value: "uploadImg"
  }
];

export const radiusOptions = [
  {
    label: "直角",
    value: "0px"
  },
  {
    label: "圆角",
    value: "15px"
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/XVideo/options.js